export const AUTH_BOOTSTRAP_CONTEXT_KEY = 'authBootstrap';

type ToastLike = {
  error: (message: string) => void;
};

interface HandleGraphQlErrorArgs {
  message: string;
  isAuthBootstrap: boolean;
  isPublicRoute: boolean;
  clearAuthData: () => void;
  toast: ToastLike;
}

export const handleGraphQlError = ({
  message,
  isAuthBootstrap,
  isPublicRoute,
  clearAuthData,
  toast,
}: HandleGraphQlErrorArgs): boolean => {
  if (message === 'Unauthorized') {
    if (isAuthBootstrap) {
      if (!isPublicRoute) {
        toast.error('Session expired. Please log in again.');
        clearAuthData();
      }

      return true;
    }

    toast.error('You do not have permission to access this resource.');

    return true;
  }

  if (message === 'Unauthorized role') {
    toast.error('You do not have permission to access this resource.');

    return true;
  }

  toast.error(message);

  return true;
};
